// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"12ddb7b7","384":"e5fabf55","404":"5aee853f","498":"7587ad77","787":"603b930e"}[chunkId] + ".chunk.js";
};